import React from 'react';
import InactiveImg from '../../../../static/img/einstein-inactive.svg';

export const TabDisabled = props => (

      <img
        src={InactiveImg}
        className="slds-illustration__svg"
        alt="Einstein Content Selection: Inactive Tab"
      />

);